import { Numeral } from '@ui/uikit/components/common/Numeral';
import type { TableColumn } from '@ui/uikit/components/common/Table';
import { UserAvatar } from '@ui/uikit/components/common/UserAvatar';

import type {
  IsSqrvVotingPowerUsed,
  IsValidationFinished,
} from '../../../ApplicationValidationSummary';
import { CHOICES_BY_ID } from '../../../constants';
import styles from './ApplicationValidationVotesTable.module.scss';

export interface ApplicationTableData {
  id: string;
  karma: number;
  name: string;
  icon: string;
  choice: 'Yes' | 'No';
  profileUrl: string;
  votingPower: number;
  membership?: "FREE" | "PLUS" | "PREMIUM" | "PREMIUM_PLUS";
}

interface GetApplicationValidationVotesTableColumnsProps
  extends IsValidationFinished,
    IsSqrvVotingPowerUsed {}

export const getApplicationValidationVotesTableColumns = ({
  isSqrvVotingPowerUsed,
  isValidationFinished,
}: GetApplicationValidationVotesTableColumnsProps): {
  columns: TableColumn<ApplicationTableData>[];
  selfColumns: TableColumn<ApplicationTableData>[];
} => {
  const columns: TableColumn<ApplicationTableData>[] = [
    {
      name: 'icon',
      label: 'Voter',
      render: ({ row }) => (
        <UserAvatar
          variant="vertical"
          size="medium"
          user={{
            name: row.name,
            karma: row.karma,
            icon: row.icon,
            profileLink: row.profileUrl,
            membership: row.membership,
          }}
        />
      ),
      contentPadding: 'none',
    },
    {
      name: 'choice',
      label: 'Decision',
      render: ({ row }) => {
        const {
          iconColor,
          icon: Icon,
          label,
        } = row.choice === 'Yes' ? CHOICES_BY_ID.approved : CHOICES_BY_ID.rejected;

        return (
          <div className={styles.choice}>
            <span className={styles.choiceLabel}>{label}</span>
            <Icon color={iconColor} height={16} width={16} />
          </div>
        );
      },
      align: 'right',
      hidden: isSqrvVotingPowerUsed && !isValidationFinished,
    },
    {
      name: 'votingPower',
      label: 'Voting power',
      render: ({ row }) => (
        <span>
          <Numeral format="compact" value={row.votingPower} /> SQRv
        </span>
      ),
      align: 'right',
      hidden: (isSqrvVotingPowerUsed && !isValidationFinished) || !isSqrvVotingPowerUsed,
    },
  ];

  const selfColumns: TableColumn<ApplicationTableData>[] = columns.map((column, index) =>
    index === 0 ? { ...column, label: 'You' } : column,
  );

  return {
    columns,
    selfColumns,
  };
};
